export const blockIconsToggleRadioButtonUnchecked = (
	<span className='material-symbols-outlined'>radio_button_unchecked</span>
);
